import { useNavigate, useParams } from 'react-router-dom';
import { setUserSession } from '../../Utils/Common';
import { useComponentDidMount, withRouter } from '../../Utils/Component';

function Auth(props) {
    const navigate = useNavigate();
    let {token, page} = useParams();

    useComponentDidMount(() => {
        // console.log(page);
        // console.log(token);
        let data = {
            "token": token,
        }
        setUserSession(token, data);
        navigate('/'+page);
    });

    return (
        <p>
            Authenticating...
        </p>
    )
}

export default withRouter(Auth);